module.exports = "pegasus/assets/themelp1/small/bg1.png";